<template>
    <main class="pagina__conteudo">
      <Cabecalho :dados="DadosDoContrato"/>  
      <Conteudo :dadosDeCobranca="DadosDeCobranca" :dadosDeNovacao="DadosDeNovacao"/>
    </main>
</template>

<script>
    import Cabecalho from './cabecalho.vue';
    import Conteudo from './conteudo.vue';
    import http from '../../adapters/http';

    export default {
        name: 'boletoOnline',
        data() {
            return { 
                DadosDoContrato: {
                    NomeDoBeneficiario: '',
                    Cpf: '',
                    NumeroDoContrato: '',
                    StatusDoFinanciamento: '',
                    Logradouro: '',
                    Bairro: '',
                    QuadraELote: '',
                    Cep: '',
                    CidadeComEstado: '',
                },
                DadosDeCobranca: {
                    CobrancasSelecionaveis: [],
                    CobrancasBloqueadas: [],
                    PossuiParcelaVencida: false,
                    PossuiParcelaDentroDoPrazoDeCarencia: false,
                    ParticipaDoMorarLegal: false,
                    PossuiCobrancas: true,
                    Prazo: 0,
                    PossuiDivergenciaDeRegraDePrimeiraParcela: false
                },
                DadosDeNovacao: {
                    PossuiNovacao: false,
                    VencimentoComCarenciaDaCobrancaDeEntrada: ''
                }
            };
        },
        components: {
            Cabecalho,
            Conteudo
        },
        created() {
            http.get('/Administracao/boletoOnline/ObterCobrancas')
                .then(dados => {
                    if (dados.PossuiFinanciamento) {
                        this.DadosDoContrato = dados.DadosDoContrato
                        this.DadosDeCobranca = dados.DadosDeCobranca
                        this.DadosDeNovacao.PossuiNovacao = dados.PossuiNovacao
                        this.DadosDeNovacao.VencimentoComCarenciaDaCobrancaDeEntrada = dados.VencimentoComCarenciaDaCobrancaDeEntrada
                        this.DadosDeCobranca.PossuiCobrancas = this.DadosDeCobranca.CobrancasSelecionaveis.length > 0 || this.DadosDeCobranca.FinanciamentoEstaBloqueado;
                    } else {
                        location.href = '/Administracao/BoletoOnline';
                    }
                });
        }
    }
</script>
